/* eslint-disable max-lines */
import { minWidth, textTransform } from '@mui/system';
import { COLOR1, COLOR4, COLOR5, ORIENTAL_ORANGE } from '../../../constants';

export const DocChecklistStyles = {
  file_size_newDesign: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '14px',
    color: '#808285',
    '@media(max-width:600px)': {
      marginBottom: '7px',
    },
  },

  file_size: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '14px',
    color: '#707070',
    '@media(max-width:600px)': {
      marginBottom: '7px',
    },
  },

  dragContent: {
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '18px',
    color: '#707070',
  },

  business_info_stepper: {
    width: '100%',
    margin: '37px 30px 24px 50px',
    '@media(max-width:600px)': {
      margin: '37px 50px 30px 50px',
    },
    '@media(max-width:650px)': {
      margin: '25px 25px 0px 25px',
    },
  },

  text_Container: {
    display: 'flex',
    alignItems: 'center',
  },

  container_box: {
    width: 'auto',
    height: 'auto',
    background: 'rgba(255, 170, 0, 0.08)',
    borderRadius: '10px',
  },

  UploadContainer: {
    '@media(min-width:600px)': {
      border: '1px solid #D0D0D0',
      boxShadow: '0px 4px 4px rgb(0 0 0 / 21%)',
      borderRadius: '6px',
    },
    '@media(max-width:600px)': {
      marginTop: '-30px',
    },
  },

  contact_heading: {
    marginBottom: '30px',
    textAlign: 'left',
    width: 'fit-content',
    font: 'normal normal bold 20px/23px Arial',
    letterSpacing: '0.14px',
    color: COLOR1,
    opacity: 1,
    '@media(max-width:650px)': {
      marginBottom: '20px',
      font: 'normal normal bold 16px/18px Arial',
      letterSpacing: '0.11px',
      color: COLOR1,
    },
  },

  contact_heading_new: {
    margin: '0 16px 20px 16px',
    textAlign: 'left',
    width: 'fit-content',
    font: 'normal normal bold 20px/23px TTNormsProBold',
    letterSpacing: '0.14px',
    color: COLOR1,
    opacity: 1,
    '@media(max-width:600px)': {
      margin: '0 0 22px 0',
      font: 'normal normal 700 22px/32px Arial',
      letterSpacing: '0.11px',
      color: COLOR1,
    },
  },

  uploadAltDocs: {
    margin: '0 16px',
    textAlign: 'left',
    width: 'fit-content',
    font: 'normal normal normal 16px/18px Arial',
    letterSpacing: '0.14px',
    color: '#222B45',
    opacity: 1,
    '@media(max-width:600px)': {
      margin: '0 0 22px 0',
      font: 'normal normal 700 16px/18px Arial',
      letterSpacing: '0.11px',
      color: '#222B45',
    },
  },

  uploadAltDocButton: {
    color: '#661C69',
    font: 'normal normal 700 16px/20px Arial',
    paddingLeft: '10px',
    '&:hover': {
      cursor: 'pointer',
    },
  },

  text_upload_later_head: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '18px',
    lineHeight: '21px',
    color: '#000000',
    marginBottom: '16px',
  },

  text_upload_later: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '18px',
    color: '#000000',
  },

  upload_grid_margin: {
    width: 'auto',
    height: 'auto',
    padding: '17px 20px 27px 20px',
    background: 'rgba(255, 170, 0, 0.08)',
    borderRadius: '10px',
    marginTop: '45px',
    marginLeft: '48px',
    marginRight: '55px',
    '@media(max-width:960px)': {
      marginRight: '55px',
      marginLeft: '44px',
    },
    '@media(max-width:745px)': {
      marginRight: '25px',
      marginLeft: '44px',
    },
    '@media(max-width:650px)': {
      marginRight: '4px',
      marginLeft: '25px',
    },
    '@media(max-width:330px)': {
      marginRight: '0px',
      marginLeft: '20px',
    },
  },

  supported_text: {
    marginTop: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    '@media(max-width:600px)': {
      display: 'block',
    },
  },

  checklist_grid_margin: {
    margin: '30px 20px 30px 20px',
    paddingTop: '90px',
    '@media(max-width:600px)': {
      marginRight: 0,
      marginLeft: 0,
      paddingTop: '80px',
    },
    '@media (min-width:600px) and (max-width:900px)': {
      marginRight: 0,
      marginLeft: 0,
      paddingTop: '130px',
    },
  },

  checklist_grid_margin_new: {
    margin: '30px 25px 30px 30px',
    '@media(max-width:600px)': {
      marginRight: 0,
      marginLeft: 0,
    },
  },

  checklist_grid_margin_no_snackbar: {
    margin: '30px 15px 20px 15px',
    '@media(max-width:600px)': {
      margin: 0,
    },
  },

  fileInput: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    opacity: 0,
    cursor: 'pointer',
  },

  uploadContainerError: {
    position: 'relative',
    height: '41px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px dashed #FFF4F5',
    cursor: 'pointer',
    background: '#FFF4F5',
    '&:focus': {
      backgroundImage:
        'repeating-linear-gradient(0deg,blue,blue 7px,transparent 8px,transparent 15px),repeating-linear-gradient(90deg,blue,blue 7px,transparent 8px,transparent 15px),repeating-linear-gradient(180deg,blue,blue 7px,transparent 8px,transparent 15px),repeating-linear-gradient(270deg,blue,blue 7px,transparent 8px,transparent 15px)',
      borderImage:
        'repeating-linear-gradient(0deg, blue, blue 1px, transparent 1px, transparent 1px)',
    },
  },

  uploadContainer: {
    position: 'relative',
    height: '41px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px dashed #808285',
    cursor: 'pointer',
    background: '#F4F4F4',
    '&:focus': {
      backgroundImage:
        'repeating-linear-gradient(0deg,blue,blue 7px,transparent 8px,transparent 15px),repeating-linear-gradient(90deg,blue,blue 7px,transparent 8px,transparent 15px),repeating-linear-gradient(180deg,blue,blue 7px,transparent 8px,transparent 15px),repeating-linear-gradient(270deg,blue,blue 7px,transparent 8px,transparent 15px)',
      borderImage:
        'repeating-linear-gradient(0deg, blue, blue 1px, transparent 1px, transparent 1px)',

      border: '1px solid #661C69',
    },
  },

  businessType: {
    paddingRight: '10px',
    font: 'normal normal 700 14px/18px Arial',
    color: '#444444',
  },

  toggle_Label_Style: {
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '18px',
    color: '#000000',
    '@media(max-width:600px)': {
      lineHeight: '18.4px',
    },
  },

  dragDropText: {
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '18px',
    fontFamily: 'Arial',
    textAlign: 'center',
  },

  chooseFile: {
    color: '#661C69',
    textDecoration: 'underline',
  },

  gridInnerDiv: {
    paddingRight: '15px',
    paddingLeft: '15px',
    paddingBottom: '10px',
    '@media(max-width:600px)': {
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: 0,
    },
  },

  displayUploaded: {
    background: '#FFFFFF',
    border: '1px solid #E8E8E8',
    borderRadius: '4px',
    height: '41px',
    display: 'flex',
    padding: '0 15px',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  progressColor: {
    backgroundColor: '#E37617',
  },

  linearBar: {
    height: '2px !important',
    backgroundColor: '#E8E8E8 !important',
    color: '#E37617',
  },

  uploadedFileName: {
    textDecoration: 'underline',
    color: '#661C69',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '16px',
    '&:hover': {
      textDecoration: 'underline',
    },
    '&:focus': {
      textDecoration: 'underline',
    },
  },

  labelCheckContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    '@media(max-width:600px)': {
      marginTop: '20px',
    },
  },

  cancelIcon: {
    cursor: 'pointer',
  },

  button_grid_Later: {
    padding: '0px 55px 50px 50px',
    justifyContent: 'flex-end',
    textAlign: 'right',
    '@media(max-width:650px)': {
      paddingBottom: '20px',
      justifyContent: 'center',
    },
    '@media(min-width:960px)': {
      paddingBottom: '40px',
    },
  },

  button_grid: {
    padding: '50px',
    justifyContent: 'flex-end',
    textAlign: 'right',
    '@media(max-width:600px)': {
      paddingBottom: '20px',
      justifyContent: 'center',
    },
    '@media(min-width:960px)': {
      paddingTop: '30px',
      paddingBottom: '40px',
    },
  },

  back_button: {
    border: `1px solid ${COLOR5}`,
    borderRadius: '25px',
    opacity: 1,
    width: '147px',
    height: '45px',
    margin: '0px 15px 0px 0px',
    font: 'normal normal bold 16px/18px Arial',
    letterSpacing: '1.01px',
    color: `${COLOR5} !important`,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: COLOR4,
    },
    '@media(max-width:650px)': {
      width: '48%',
      maxWidth: '160px',
    },
    '@media(max-width:360px)': {
      width: '45%',
    },
    '@media(max-width:300px)': {
      font: 'normal normal bold 14px Arial',
    },
  },

  disabled_button: {
    '&.MuiButton-root.Mui-disabled': {
      background: `${COLOR5} 0% 0% no-repeat padding-box`,
      borderRadius: '25px',
      width: '147px',
      height: '45px',
      font: 'normal normal bold 16px/18px Arial',
      letterSpacing: '1.01px',
      color: COLOR4,
      textTransform: 'none',
      '&:hover': {
        backgroundColor: COLOR5,
      },
      '@media(max-width:960px)': {
        marginRight: 0,
      },
      '@media(max-width:650px)': {
        width: '45%',
        maxWidth: '160px',
      },
      '@media(max-width:360px)': {
        width: '45%',
      },
    },
  },

  continue_button: {
    border: `1px solid ${COLOR5}`,
    background: `${COLOR5} 0% 0% no-repeat padding-box`,
    borderRadius: '25px',
    opacity: 1,
    width: '147px',
    height: '45px',
    font: 'normal normal bold 16px/18px Arial',
    textTransform: 'none',
    letterSpacing: '1.01px',
    color: COLOR4,
    '&:hover': {
      backgroundColor: COLOR5,
    },
    '@media(max-width:650px)': {
      width: '45%',
      maxWidth: '160px',
    },
    '@media(max-width:360px)': {
      width: '45%',
    },
    '@media(max-width:300px)': {
      font: 'normal normal bold 14px Arial',
    },
    '&.Mui-disabled span': {
      opacity: 0.6,
    },
  },

  box: {
    width: '100%',
    height: '61px',
    fontSize: '14px',
    lineHeight: 1,
    borderRadius: '4px',
    backgroundPosition: '0 0, 0 0, 100% 0, 0 100%',
    backgroundSize: '1px 100%, 100% 1px, 1px 100%, 100% 1px',
    backgroundRepeat: 'no-repeat',
  },

  box_new_design: {
    width: '100%',
    height: '91px',
    fontSize: '14px',
    lineHeight: 1,
    borderRadius: '4px',
    backgroundPosition: '0 0, 0 0, 100% 0, 0 100%',
    backgroundSize: '1px 100%, 100% 1px, 1px 100%, 100% 1px',
    backgroundRepeat: 'no-repeat',
  },

  box_a_new_design: {
    width: '100%',
    borderRadius: '4px',
    backgroundColor: '#ffffff',
    backgroundImage:
      'repeating-linear-gradient(0deg,#D0D0D0,#D0D0D0 7px,transparent 8px,transparent 15px),repeating-linear-gradient(90deg,#D0D0D0,#D0D0D0 7px,transparent 8px,transparent 15px),repeating-linear-gradient(180deg,#D0D0D0,#D0D0D0 7px,transparent 8px,transparent 15px),repeating-linear-gradient(270deg,#D0D0D0,#D0D0D0 7px,transparent 8px,transparent 15px)',
    borderImage:
      'repeating-linear-gradient(0deg, #D0D0D0, #D0D0D0 1px, transparent 1px, transparent 1px)',
    '@media(max-width:750px)': {
      maxWidth: '100%',
    },
    '@media(max-width:600px)': {
      width: '100%',
    },
  },

  box_a: {
    width: '100%',
    borderRadius: '4px',
    backgroundImage:
      'repeating-linear-gradient(0deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(90deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(180deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(270deg,#808285,#808285 7px,transparent 8px,transparent 15px)',
    borderImage:
      'repeating-linear-gradient(0deg, #808285, #808285 1px, transparent 1px, transparent 1px)',
    '@media(max-width:750px)': {
      maxWidth: '100%',
    },
    '@media(max-width:600px)': {
      width: '100%',
    },
  },

  file_size_Error: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '14px',
    color: '#D71721',
  },

  box_a_Error: {
    width: '100%',
    backgroundImage:
      'repeating-linear-gradient(0deg,#D71721,#D71721 7px,transparent 8px,transparent 15px),repeating-linear-gradient(90deg,#D71721,#D71721 7px,transparent 8px,transparent 15px),repeating-linear-gradient(180deg,#D71721,#D71721 7px,transparent 8px,transparent 15px),repeating-linear-gradient(270deg,#D71721,#D71721 7px,transparent 8px,transparent 15px)',
    borderImage:
      'repeating-linear-gradient(0deg, #D71721, #D71721 1px, transparent 1px, transparent 1px)',
  },

  gridItem: {
    '@media (min-width:600px) and (max-width:745px)': {
      flexBasis: '100%',
      maxWidth: '100%',
    },
    '@media(max-width:600px)': {
      padding: '0',
    },
  },

  snackbarMargin: {
    position: 'relative',
    '@media(max-width:600px)': {
      margin: '25px 0 50px 0',
    },
    // '@media(max-width:450px)': {
    //   margin: 0,
    // },
  },

  snackbarRoot: {
    width: '100%',
    height: '43px',
    position: 'absolute',
    zIndex: '1',
    display: 'inline-block',
    justifyContent: 'flex-end',
    top: '20px',
    left: '0 !important',
    right: '0 !important',
    '@media(max-width:600px)': {
      top: '15px',
    },
    '@media(max-width:375px)': {
      top: 0,
      marginTop: '-25px',
    },
  },

  snackBarBtn: {
    padding: '0px',
    height: '20px',
    marginTop: '10px',
    color: COLOR1,
  },

  snackbarStyleViaContentProps: {
    color: COLOR1,
    backgroundColor: ORIENTAL_ORANGE,
    // width: '100%',
    minWidth: 'unset',
    font: 'normal 700 14px/22px Arial',
    padding: '7.6px 20px',
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'nowrap',
    '@media(min-width:600px)': {
      margin: '0px 20px 0px 20px',
      minWidth: 'unset',
    },
  },

  message: {
    width: '100%',
    display: 'flex',
  },

  contentDiv: {
    '@media(min-width:600px)': {
      border: '1px solid #D0D0D0',
      boxShadow: '0px 4px 4px rgb(0 0 0 / 21%)',
      borderRadius: '6px',
    },
  },

  grid_container: {
    padding: '10px 0px 16px 0',
    '@media(max-width:600px)': {
      padding: '0 20px 0 0',
    },
  },
};
